<template>
  <div class="cardCon">
    <Tabs v-model="navType">
      <TabPane :name="item.id" :label="item.title" v-for="(item, index) in data" :key="index">
        <template v-if="item.id == 0">
          <processCom />
        </template>
        <template v-else-if="item.id == 1">
          <fileCom />
        </template>
        <template v-else-if="item.id == 2">
          <modelCom />
        </template>
        <template v-else-if="item.id == 3">
          <networkCom />
        </template>
        <template v-else-if="item.id == 4">
          <registryCom />
        </template>
        <template v-else-if="item.id == 5">
          <driveCom />
        </template>
        <template v-else-if="item.id == 6">
          <driveReturnCom />
        </template>
        <template v-else-if="item.id == 7">
          <injectionPro />
        </template>
        <template v-else-if="item.id == 8">
          <windowCom />
        </template>
        <template v-else-if="item.id == 9">
          <windowReCom />
        </template>
        <template v-else-if="item.id == 11">
          <processPro />
        </template>
        <template v-else-if="item.id == 12">
          <processHide />
        </template>
      </TabPane>
    </Tabs>
    <p class="clearfix btnCon">
      <ButtonGroup type="button" class="fr" v-model="type">
        <Button type="primary" label="1" @click="editorFn">添加</Button>
        <Button type="primary" label="2">清空</Button>
        <Button type="primary" label="2">导入</Button>
        <Button type="primary" label="2">导出</Button>
      </ButtonGroup>
    </p>
    <editorCom :title="title" ref="editorCom" :type="navType" />
  </div>
</template>
<script>
import processCom from './processCom.vue'
import fileCom from './file.vue'
import networkCom from './network.vue'
import modelCom from './model.vue'
import registryCom from './registry.vue'
import driveCom from './drive.vue'
import driveReturnCom from './driveReturn.vue'
import injectionPro from './injectionPro.vue'
import windowCom from './windowCom.vue'
import windowReCom from './windowReCom.vue'
import processPro from './processPro.vue'
import processHide from './processHide.vue'
import editorCom from './editorCom.vue'
export default {
  components: {
    processCom,
    fileCom,
    modelCom,
    networkCom,
    registryCom,
    driveCom,
    driveReturnCom,
    injectionPro,
    windowCom,
    windowReCom,
    processPro,
    processHide,
    editorCom
  },
  data () {
    return {
      title: '新增',
      data: [
        {
          title: '进程',
          id: 0,
        },
        {
          title: '文件',
          id: 1,
        },
        {
          title: '模块',
          id: 2
        },
        {
          title: '网络',
          id: 3
        },
        {
          title: '注册表',
          id: 4
        },
        {
          title: '驱动',
          id: 5
        },
        {
          title: '驱动回调',
          id: 6,
        },
        {
          title: '注入保护',
          id: 7
        },
        {
          title: '窗口',
          id: 8
        },
        {
          title: '窗口枚举',
          id: 9
        },
        // {
        //   title: '插件',
        //   id: 10
        // },
        {
          title: '进程保护',
          id: 11
        },
        {
          title: '进程隐藏',
          id: 12
        }
      ],
      navType: 0
    }
  },
  methods: {
    editorFn (val) {
      (this).$refs.editorCom.visible = true
    }
  },
}
</script>
<style lang="scss" scoped>
.btnCon {
  padding-top: 20px;
}
</style>
<style lang="scss" >
.ivu-tabs-nav-wrap {
  background: #F5F7FA;
}

.cardCon {
  .ivu-tabs {
    border: 1px solid #DCDFE6;
    background: #fff;
    box-shadow: 0 10 10px rgba($color: #000000, $alpha: .5);
    width: calc(100% - 4px);
    border-radius: 4px;
  }

  .ivu-table:before {
    height: 0;
  }
}
</style>